import {
  USERS_START,
  USERS_SUCCESS,
  UGROUP_START,
  UGROUP_SUCCESS,
  PERMISSIONINBATCH_START,
  PERMISSIONINBATCH_SUCCESS,
  PERMISSIONINBATCH_TX_START,
  PERMISSIONINBATCH_TX_SUCCESS,
  PERMISSION_UGROUP_START,
  PERMISSION_UGROUP_SUCCESS,
  PERMISSION_USER_START,
  PERMISSION_USER_SUCCESS,
} from "../types/index";

const getUserStart = () => {
  return {
    type: USERS_START,
  };
};

const getUserSuccess = (data) => {
  return {
    type: USERS_SUCCESS,
    users: data,
  };
};

const getUgroupStart = () => {
  return {
    type: UGROUP_START,
  };
};

const getUgroupSuccess = (data) => {
  return {
    type: UGROUP_SUCCESS,
    ugroups: data,
  };
};

const getPermissionInBatchStart = () => {
  return {
    type: PERMISSIONINBATCH_START,
  };
};

const getPermissionInBatchSuccess = (data) => {
  return {
    type: PERMISSIONINBATCH_SUCCESS,
    permissionInBatch: data,
  };
};

const getPermissionInBatchTXStart = () => {
  return {
    type: PERMISSIONINBATCH_TX_START,
  };
};

const getPermissionInBatchTXSuccess = (data) => {
  return {
    type: PERMISSIONINBATCH_TX_SUCCESS,
    permissionInBatchTX: data,
  };
};

const getPermissionUgroupSuccess = (data) => {
  return {
    type: PERMISSION_UGROUP_SUCCESS,
    ugroupPerms: data,
  };
};

const getPermissionUgroupStart = () => {
  return {
    type: PERMISSION_UGROUP_START,
  };
};

const getPermissionUserStart = () => {
  return {
    type: PERMISSION_USER_START,
  };
};

const getPermissionUserSuccess = (data) => {
  return {
    type: PERMISSION_USER_SUCCESS,
    userPerms: data,
  };
};

export {
  getUserStart,
  getUserSuccess,
  getUgroupStart,
  getUgroupSuccess,
  getPermissionInBatchStart,
  getPermissionInBatchSuccess,
  getPermissionInBatchTXStart,
  getPermissionInBatchTXSuccess,
  getPermissionUgroupStart,
  getPermissionUgroupSuccess,
  getPermissionUserStart,
  getPermissionUserSuccess,
};
